<template>
  <section class="table by9">
    <ul>
      <li>
        <label class="sort reset" @click="reset()">PARTENAIRE</label>
        <label><i style="color: var(--grey-dark);">⬤</i></label>
        <label><i style="color: var(--yellow);">⬤</i></label>
        <label><i style="color: var(--reserved);">⬤</i></label>
        <label><i style="color: var(--financed);">⬤</i></label>
        <label><i style="color: var(--acted);">⬤</i></label>
        <label class="sort" :class="classActive('count')" @click="sortby('count')">NOMBRE</label>
        <label class="sort" :class="classActive('ca')" @click="sortby('ca')">PRIX</label>
        <label>P.C</label>
      </li>
    </ul>
    <ul>
      <li v-for="(user, u) in sorted" :key="u">
        <span>{{ user.lastname }} {{ user.firstname | initial }}</span>
        <span>
          {{ user.status.count[0] }}
        </span>
        <span>
          {{ user.status.count[1] }}
          <small v-if="user.status.price[1] > 0">({{ user.status.price[1] | euros }})</small>
        </span>
        <span>
          {{ user.status.count[2] }}
          <small v-if="user.status.price[2] > 0">({{ user.status.price[2] | euros }})</small>
        </span>
        <span>
          {{ user.status.count[3] }}
          <small v-if="user.status.price[3] > 0">({{ user.status.price[3] | euros }})</small>
        </span>
        <span>
          {{ user.status.count[4] }}
          <small v-if="user.status.price[4] > 0">({{ user.status.price[4] | euros }})</small>
        </span>
        <span>{{ user.count }}</span>
        <span>{{ user.ca | euros }}</span>
        <span>{{ user.pc }} %</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StatisticsProgramPartner',
  props: {
    numero: Number,
    customlots: Array,
    customReservations: Array,
    tva: Boolean,
    option: Boolean
  },
  data () {
    return {
      types: 13,
      dir: false,
      sort: 'count'
    }
  },
  computed: {
    lots: function () {
      if (this.numero === -1) return this.customlots
      return this.$store.getters.get_lots_by_program_num(this.numero)
    },
    programs: function () {
      return this.$store.getters.get_programs()
    },
    totals: function () {
      return this.lots.reduce((sum, l) => sum + Number(l?.spec?.price ?? 0), 0)
    },
    reservations: function () {
      if (this.numero === -1) return this.customReservations
      return this.$store.getters.get_reservations_by_program_num(this.numero)
    },
    users: function () {
      return this.$store.getters.get_users()
    },
    usersProgram: function () {
      const usersMap = new Map(this.users.map(u => [u.username, u]))
      const totals = this.totals
      const result = new Map()

      this.reservations.forEach(r => {
        const user = usersMap.get(r.user.username)
        if (!user) return

        const key = user.username
        const mylot = this.$store.getters.get_lot_by_uid(r.lot.uid)
        const myprice = this.tva
          ? Number(r.lot.calculatedprice) || 0
          : Number(mylot?.spec?.price ?? 0)

        if (!result.has(key)) {
          result.set(key, {
            username: user.username,
            firstname: user.meta.firstname,
            lastname: user.meta.lastname,
            status: { count: [0, 0, 0, 0, 0], price: [0, 0, 0, 0, 0] },
            count: 0,
            ca: 0,
            pc: 0
          })
        }

        const userData = result.get(key)
        userData.status.count[r.status]++
        userData.status.price[r.status] += myprice

        if (this.option) {
          if (r.status > 0) {
            userData.count++
            userData.ca += myprice
            userData.pc = Number(((userData.ca / totals) * 100).toFixed(2))
          }
        } else {
          if (r.status > 1) {
            userData.count++
            userData.ca += myprice
            userData.pc = Number(((userData.ca / totals) * 100).toFixed(2))
          }
        }
      })
      return Array.from(result.values())
    },
    sorted: function () {
      var dir = this.dir
      var sort = this.sort
      return this.usersProgram.slice().sort(function (a, b) {
        if (dir) return (a[sort] > b[sort]) ? 1 : -1
        return (a[sort] < b[sort]) ? 1 : -1
      })
    }
  },
  methods: {
    sortby: function (value) {
      if (this.sort === value) {
        if (this.dir) this.dir = false
        else this.dir = true
      } else {
        this.sort = value
      }
    },
    reset: function () {
      this.sort = 'count'
      this.dir = true
    },
    classActive: function (value) {
      var classe = ''
      if (this.sort === value) classe = 'active'
      if (this.dir === false) classe += ' dir'
      return classe
    }
  }
}
</script>
